import type { ConstValues } from './helpers';
import type { I18nTranslate } from './translations';
export const rboConfigModelGoal = {
  CLICK: 'click',
  CONVERSION: 'conversion',
} as const;
export type RboConfigModelGoal = ConstValues<typeof rboConfigModelGoal>;

export const rboConfigChannel = {
  BANNER: 'banner',
  VIDEO: 'video',
} as const;
export type RboConfigChannel = ConstValues<typeof rboConfigChannel>;

export const rboConfigTactic = {
  DYNAMIC: 'dynamic',
  FIXED: 'fixed',
  LW_QUANTILE_BOOST: 'lw_quantile_boost',
} as const;
export type RboConfigTactic = ConstValues<typeof rboConfigTactic>;

export const rboConfigTarget = {
  AUTOMOTIVE: 'automotive',
  BEAUTY_HYGENE: 'beauty_hygene',
  COMPUTER_ELECTRONICS: 'computers_electronics',
  ENTERTAINMENT: 'entertainment',
  FOOD_BEVERAGE: 'food_beverage',
  MASS_MERCHANTS: 'mass_merchants',
  TRAVEL_PLANNING: 'travel_planning',
} as const;
export type RboConfigTarget = ConstValues<typeof rboConfigTarget>;

export const getRboTranslations = (t: I18nTranslate) => {
  const tacticOptions = {
    [rboConfigTactic.DYNAMIC]: t('Dynamic'),
    [rboConfigTactic.FIXED]: t('Fixed'),
    [rboConfigTactic.LW_QUANTILE_BOOST]: t('LW Quantile Boost'),
  };
  const channelOptions = { [rboConfigChannel.BANNER]: t('Banner'), [rboConfigChannel.VIDEO]: t('Video') };
  const modelGoalOptions = {
    [rboConfigModelGoal.CLICK]: t('Click'),
    [rboConfigModelGoal.CONVERSION]: t('Conversion'),
  };
  const targetOptions = {
    [rboConfigTarget.AUTOMOTIVE]: t('Automotive'),
    [rboConfigTarget.BEAUTY_HYGENE]: t('Beauty & Hygiene'),
    [rboConfigTarget.COMPUTER_ELECTRONICS]: t('Computers & Electronics'),
    [rboConfigTarget.ENTERTAINMENT]: t('Entertainment'),
    [rboConfigTarget.FOOD_BEVERAGE]: t('Food & Beverage'),
    [rboConfigTarget.MASS_MERCHANTS]: t('Mass merchants'),
    [rboConfigTarget.TRAVEL_PLANNING]: t('Travel & Planning'),
  };

  return {
    targetOptions,
    modelGoalOptions,
    channelOptions,
    tacticOptions,
  };
};
